/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FusionMelcoModelsCanvasPreview
 */
export interface FusionMelcoModelsCanvasPreview {
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsCanvasPreview
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsCanvasPreview
     */
    url?: string | null;
}

export function FusionMelcoModelsCanvasPreviewFromJSON(json: any): FusionMelcoModelsCanvasPreview {
    return FusionMelcoModelsCanvasPreviewFromJSONTyped(json, false);
}

export function FusionMelcoModelsCanvasPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoModelsCanvasPreview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function FusionMelcoModelsCanvasPreviewToJSON(value?: FusionMelcoModelsCanvasPreview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'url': value.url,
    };
}


